import { forwardRef } from "react";
import { cx } from "../cx";
import { Icon } from "../Icon";
import { Input, type InputProps } from "../Input";
import styles from "./SearchInput.module.css";

export interface SearchInputProps extends Omit<InputProps, "value" | "onChange" | "prefix" | "suffix" | "type"> {
  value: string;
  onChange: (value: string) => void;
  clearLabel?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { value, onChange, clearLabel = "Clear search", placeholder = "Search", className, onKeyDown, ...rest },
  ref,
) {
  return (
    <Input
      ref={ref}
      type="search"
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        // First Escape clears; only an empty field lets Escape bubble up and close the surrounding popover.
        if (e.key === "Escape" && value !== "") {
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
          onChange("");
          return;
        }
        onKeyDown?.(e);
      }}
      prefix={<Icon name="search" size={16} />}
      suffix={
        value ? (
          <button type="button" className={styles.clear} aria-label={clearLabel} onClick={() => onChange("")}>
            <Icon name="close" size={14} />
          </button>
        ) : undefined
      }
      className={cx(styles.input, className)}
      {...rest}
    />
  );
});
